










































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import dayjs from 'dayjs';
import { Public } from "@/http/api_Public";
import { fmoney,fmoneynew } from "@/common/util/money";
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class employeeBilling extends Vue {
  fmoneynew = fmoneynew;
  timeValue = [dayjs(new Date()).startOf("month").format("YYYY-MM-DD"),dayjs(new Date()).endOf("month").format("YYYY-MM-DD")];
  /**登陆信息 */
  public userInfo = JSON.parse(localStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  totalForm = {};
  exloading = false;
  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    start: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).endOf("month").format("YYYY-MM-DD") + " " + "23:59:59",
    Key: "",
    skip: 0,
    count: 10,
  };
  async mounted() {
    await this.getlist();
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetTbHandoverList(this.searchValue);
    this.listData = result.items.map(v=>{
      return {
        ...v,
        timefirst:v.workClass.split(" - ")[0],
        timeend:v.workClass.split(" - ")[1],
      }
    });
    this.total = result.totalCount;
    let result2 = await Public.GetHandoverTotal(this.searchValue);
    this.totalForm = result2;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [dayjs(new Date()).startOf("month").format("YYYY-MM-DD"),dayjs(new Date()).endOf("month").format("YYYY-MM-DD")];
    this.searchValue = {
      start: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
      end: dayjs(new Date()).endOf("month").format("YYYY-MM-DD") + " " + "23:59:59",
      Key: "",
      skip: 0,
      count: 10,
    };
    await this.getlist();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.start = val[0] + " " + "00:00:00";
      this.searchValue.end = val[1]+ " " + "23:59:59";
    } else {
      this.searchValue.start = "";
      this.searchValue.end = "";
    }
  }
  /**统计合计 */
  getSummaries(param) {
    const { columns, data } = param;
    const sums:any = [];
    let sumTotal = this.jsHj();

    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = `合计`;
            return;
        }
        sums[index] = sumTotal[column.property];
    });

    return sums;
  }
  jsHj() {
    let form = {
        balanceCash: '',
        imprest: '',
        cash:'',
        salesAmount:'',
        salesAmountNum:'',
        salesAmountCash:'',
        salesAmountCard:'',
        // 
        salesAmountOfflineWeChat:'',
        salesAmountOfflineAlipay:'',
        salesAmountWeChat:'',
        salesAmountAlipay:'',
        returnAmountNum:'',
        returnAmount:'',
        returnAmountCash:'',
        returnAmountCard:'',
        // 
        returnAmountOfflineWeChat:'',
        returnAmountOfflineAlipay:'',
        returnAmountWeChat:'',
        returnAmountAlipay:'',
        addMemberNum:'',
        rechargePriceNum:'',
        rechargePrice:'',
        rechargePriceCash:'',
        // 
        rechargePriceOfflineWeChat:'',
        rechargePriceOfflineAlipay:'',
        rechargePriceWeChat:'',
        rechargePriceAlipay:'',

    },
    arr = this.listData;
    if (arr.length > 0) {
        form = {
          balanceCash: fmoneynew(this.totalForm['total_BalanceCash'],2),
          imprest: fmoneynew(this.totalForm['total_Imprest'],2),
          cash:fmoneynew(this.totalForm['total_Cash'],2),
          salesAmount:fmoneynew(this.totalForm['total_SalesAmount'],2),
          salesAmountNum: this.totalForm['total_SalesAmountNum'],
          salesAmountCash:fmoneynew(this.totalForm['total_SalesAmountCash'],2),
          salesAmountCard:fmoneynew(this.totalForm['total_SalesAmountCard'],2),
          // 
          salesAmountOfflineWeChat:fmoneynew(this.totalForm['total_SalesAmountOfflineWeChat'],2),
          salesAmountOfflineAlipay:fmoneynew(this.totalForm['total_SalesAmountOfflineAlipay'],2),
          salesAmountWeChat:fmoneynew(this.totalForm['total_SalesAmountWeChat'],2),
          salesAmountAlipay:fmoneynew(this.totalForm['total_SalesAmountAlipay'],2),
          returnAmountNum:this.totalForm['total_ReturnAmountNum'],
          returnAmount:'-'+fmoneynew(this.totalForm['total_ReturnAmount'],2),
          returnAmountCash:'-'+fmoneynew(this.totalForm['total_ReturnAmountCash'],2),
          returnAmountCard:'-'+fmoneynew(this.totalForm['total_ReturnAmountCard'],2),
          // 
          returnAmountOfflineWeChat:'-'+fmoneynew(this.totalForm['total_ReturnAmountOfflineWeChat'],2),
          returnAmountOfflineAlipay:'-'+fmoneynew(this.totalForm['total_ReturnAmountOfflineAlipay'],2),
          returnAmountWeChat:'-'+fmoneynew(this.totalForm['total_ReturnAmountWeChat'],2),
          returnAmountAlipay:'-'+fmoneynew(this.totalForm['total_ReturnAmountAlipay'],2),
          addMemberNum:this.totalForm['total_AddMemberNum'],
          rechargePriceNum:this.totalForm['total_RechargePriceNum'],
          rechargePrice:fmoneynew(this.totalForm['total_RechargePrice'],2),
          rechargePriceCash:fmoneynew(this.totalForm['total_RechargePriceCash'],2),
          // 
          rechargePriceOfflineWeChat:fmoneynew(this.totalForm['total_RechargePriceOfflineWeChat'],2),
          rechargePriceOfflineAlipay:fmoneynew(this.totalForm['total_RechargePriceOfflineAlipay'],2),
          rechargePriceWeChat:fmoneynew(this.totalForm['total_RechargePriceWeChat'],2),
          rechargePriceAlipay:fmoneynew(this.totalForm['total_RechargePriceAlipay'],2),
        };
    }
    return form;
  }
  export_table() {
    try {
      this.exloading = true;
      Public.TbHandoverExport(Object.assign({},this.searchValue)).then((res) => {
        var fileName = "员工交接班报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/employeeHandover/index.vue